/**
 * WES guided program creation — public API for admin setup routes and shared setup UI.
 *
 * @packageDocumentation
 */

/** Build org-admin URLs for the guided setup flow. */
export {
  getGuidedProgramCreationSetupUrl,
  getGuidedProgramCreationLearningPlanUrl,
  getGuidedProgramCreationInviteUrl,
  getSkipProgramCreationUrl,
} from './utils/guidedProgramCreationRoutes';
export type { GuidedProgramCreationRouteOptions } from './utils/guidedProgramCreationRoutes';

/** Static options for the Step 1 organization profile form. */
export {
  getIndustryOptions,
  getJobTitleOptions,
  getAudienceOptions,
  MAX_AUDIENCE_SELECTIONS,
} from './constants/organizationProfileOptions';
export type { OrganizationProfileOption } from './constants/organizationProfileOptions';
export { getOrganizationProfileOptionLabel } from './utils/organizationProfileOptionLookup';

/** Stepper labels for {@link GuidedProgramCreationStepLayout}. */
export { getGuidedProgramCreationStepperSteps } from './constants/guidedProgramCreationStepper';

/** Gate + context wrapper for `/admin/setup/*` routes. */
export { default as GuidedProgramCreationRouteGuard } from './components/GuidedProgramCreationRouteGuard';
export { default as GuidedProgramCreationPageLayout } from './components/layout/GuidedProgramCreationPageLayout';
export {
  GuidedProgramCreationContextProvider,
  useGuidedProgramCreationContext,
} from './context/GuidedProgramCreationContext';
export { default as useOrganizationProfile } from './hooks/useOrganizationProfile';
export type { OrganizationProfile } from './hooks/useOrganizationProfile';
export { default as useGuidedProgramCreationResume } from './hooks/useGuidedProgramCreationResume';
export { default as GuidedProgramCreationResumeBanners } from './components/GuidedProgramCreationResumeBanners';
export { default as GuidedProgramCreationStepLayout } from './components/layout/GuidedProgramCreationStepLayout';
export { default as GuidedProgramCreationStepFooter } from './components/layout/GuidedProgramCreationStepFooter';
export { default as GuidedProgramCreationSetupPage } from './components/setup/GuidedProgramCreationSetupPage';
export { default as GuidedProgramCreationLearningPlanPage } from './components/setup/GuidedProgramCreationLearningPlanPage';
export { default as GuidedProgramCreationInvitePage } from './components/setup/GuidedProgramCreationInvitePage';

/** Route-level code splitting for `admin-dashboard` setup routes. */
export const GuidedProgramCreationPageLayoutDynamic = () =>
  import('./components/layout/GuidedProgramCreationPageLayout');
export const GuidedProgramCreationSetupPageDynamic = () => import('./components/setup/GuidedProgramCreationSetupPage');
export const GuidedProgramCreationLearningPlanPageDynamic = () =>
  import('./components/setup/GuidedProgramCreationLearningPlanPage');
export const GuidedProgramCreationInvitePageDynamic = () =>
  import('./components/setup/GuidedProgramCreationInvitePage');
